import { render } from "./RequestsTable.vue?vue&type=template&id=561303da&scoped=true"
import script from "./RequestsTable.vue?vue&type=script&lang=js"
export * from "./RequestsTable.vue?vue&type=script&lang=js"

import "./RequestsTable.vue?vue&type=style&index=0&id=561303da&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-561303da"

export default script